import React from "react";
import clsx from "clsx";
import { AthleteRabbit as AthleteRabbitType } from "../../SegmentAnalysisMap.types";

import styles from "./AthleteRabbit.scss";

interface AthleteRabbitProps {
  athlete: AthleteRabbitType;
}

export const AthleteRabbit = ({ athlete }: AthleteRabbitProps) => {
  const { name = "", photoUrl, index } = athlete;

  return (
    <div className={clsx(styles.rabbit, styles[`position${index}`])}>
      <svg viewBox="0 0 28 38" width="28" height="38">
        <path d="M13.3528289,37.248682 C13.7102516,37.6636235 14.2924099,37.66333 14.6564713,37.237741 C14.6564713,37.237741 28,22.1200581 28,14.25 C28,6.37994193 21.7319869,0 14,0 C6.26801312,0 0,6.37994193 0,14.25 C0,22.1200581 13.3528289,37.248682 13.3528289,37.248682 Z" />
      </svg>
      {photoUrl && (
        <div className={styles.avatar}>
          <img alt={name} src={photoUrl} />
        </div>
      )}
    </div>
  );
};

export default AthleteRabbit;
